import { render } from "./sizeGrid.vue?vue&type=template&id=0cb88ab0&scoped=true"
import script from "./sizeGrid.vue?vue&type=script&lang=js"
export * from "./sizeGrid.vue?vue&type=script&lang=js"

import "./sizeGrid.vue?vue&type=style&index=0&id=0cb88ab0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb88ab0"]])

export default __exports__